/* Hjelpefunksjonar for stader og Google Maps-lenker (ingen API-nøkkel trengst for deep links). */

export const placeLabel = (p) => (p ? p.name || p.address || "" : "");
export const placeQuery = (p) => (p ? p.address || p.name || "" : "");
export const hasPlace = (p) => Boolean(p && (p.address || p.name || p.place_id));

/** Køyrerute i Google Maps (opnar Maps-appen på mobil). */
export function directionsUrl({ origin, destination, stops = [] }) {
  if (!hasPlace(origin) || !hasPlace(destination)) return null;
  const params = new URLSearchParams({ api: "1", travelmode: "driving" });
  params.set("origin", placeQuery(origin));
  if (origin.place_id) params.set("origin_place_id", origin.place_id);
  params.set("destination", placeQuery(destination));
  if (destination.place_id) params.set("destination_place_id", destination.place_id);
  const valid = (stops || []).filter(hasPlace);
  if (valid.length) {
    params.set("waypoints", valid.map(placeQuery).join("|"));
    if (valid.every((s) => s.place_id)) params.set("waypoint_place_ids", valid.map((s) => s.place_id).join("|"));
  }
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

/** Éin stad i Google Maps. */
export function placeUrl(place) {
  if (!hasPlace(place)) return null;
  const params = new URLSearchParams({ api: "1", query: placeQuery(place) });
  if (place.place_id) params.set("query_place_id", place.place_id);
  return `https://www.google.com/maps/search/?${params.toString()}`;
}

export const ROUTE_SOURCE = {
  google: { label: "Google-rute", tone: "success" },
  osrm: { label: "Berekna rute", tone: "info" },
  estimat: { label: "Estimat", tone: "warning" },
  manuell: { label: "Manuelt sett", tone: "neutral" },
};

export const fmtKm = (km) => (km === null || km === undefined || km === "" ? "–" : `${String(Number(km).toFixed(1)).replace(".", ",")} km`);
